@let problem = problem$ | async;
@let appMode = appMode$ | async;
@let editingOrAdding = appMode === "edit" || appMode === "add";
@let inProgress = inProgress$ | async;

@if (problem) {
    <div class="card">
        <div class="card-body">
            @if (form) {
                <la-problem-details
                    [problem]="problem"
                    [langproPrediction]="form.controls.langproPrediction.value"
                    [usedKBItems]="form.controls.usedKbItems.value"
                />
                <div class="d-flex flex-column">
                    <la-premises-form [form]="form" />
                    <hr />
                    <la-knowledge-base-form [form]="form" />
                </div>
                <div class="card my-3">
                    <div class="card-body d-flex gap-2">
                        <div class="flex-fill">
                            @if (!inProgress) {
                                <la-icon-button
                                    buttonStyle="success"
                                    [icon]="faTree"
                                    label="Parse and prove"
                                    (click)="startParse()"
                                    fullWidth
                                />
                            } @else {
                                <la-icon-button
                                    buttonStyle="success"
                                    [icon]="faHourglass"
                                    label="Parsing and proving..."
                                    disabled="true"
                                    fullWidth
                                />
                            }
                        </div>
                        @if (this.form.dirty || editingOrAdding) {
                            <div class="flex-fill">
                                <la-icon-button
                                    buttonStyle="primary"
                                    [icon]="faFloppyDisk"
                                    label="Save problem"
                                    (click)="saveProblem()"
                                    fullWidth
                                />
                            </div>
                        }
                    </div>
                </div>
            }
        </div>
    </div>
} @else {
    <div
        class="h-100 d-flex align-items-center justify-content-center text-muted"
    >
        <fa-icon [icon]="faExclamationCircle"></fa-icon>
        <h2 class="h4 mb-0 ms-2">
            There are no problems matching your search criteria.
        </h2>
    </div>
}
